import React, { useState } from "react";
import {
  GridFill,
  PeopleFill,
  HeartPulseFill,
  BarChartFill,
  CalendarCheckFill,
  PersonLinesFill,
  FileEarmarkBarGraphFill,
  Clipboard2PulseFill,
  HospitalFill,
  GearFill,
  ChevronDown,
  ChevronRight,
  BoxArrowRight,
} from "react-bootstrap-icons";

import "bootstrap/dist/css/bootstrap.min.css";

const modules = [
  {
    moduleName: "MIS",
    icon: <BarChartFill />,
    menus: [
      { name: "Dashboard", icon: <GridFill /> },
      { name: "Reports", icon: <FileEarmarkBarGraphFill /> },
      { name: "Analytics", icon: <BarChartFill /> },
    ],
  },

  {
    moduleName: "HRIS",
    icon: <PeopleFill />,
    menus: [
      { name: "Employee Info", icon: <PersonLinesFill /> },
      { name: "Attendance", icon: <CalendarCheckFill /> },
      { name: "Leave", icon: <Clipboard2PulseFill /> },
      { name: "Promotion", icon: <PeopleFill /> },
      { name: "Transfer", icon: <PeopleFill /> },
    ],
  },

  {
    moduleName: "MEDICAL",
    icon: <HeartPulseFill />,
    menus: [
      { name: "Patient List", icon: <HospitalFill /> },
      { name: "Medical Reports", icon: <Clipboard2PulseFill /> },
      { name: "Doctors", icon: <PeopleFill /> },
    ],
  },

  {
    moduleName: "SETTINGS",
    icon: <GearFill />,
    menus: [
      { name: "User Settings", icon: <GearFill /> },
      { name: "Permissions", icon: <GearFill /> },
    ],
  },
];

const Dashboard = () => {
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [openModule, setOpenModule] = useState("MIS");

  const toggleModule = (moduleName) => {
    setOpenModule(openModule === moduleName ? "" : moduleName);
  };

  return (
    <div className="container-fluid" style={{marginTop:100}}>
      <div className="row">

        {/* Sidebar */}
        {/* <div className="col-lg-2 col-md-3 p-0"  style={{ minHeight: "100vh",  background: "#1e293b", color: "white", }} >

          <div className="p-3 text-center border-bottom" style={{ background: "#0f172a" }}>
            <h4 className="fw-bold">Enterprise ERP</h4>
          </div>

    
          <div className="p-2">

            {modules.map((module, index) => (
              <div key={index} className="mb-2">

          
                <div className="d-flex justify-content-between align-items-center p-2 rounded"
                  style={{ cursor: "pointer",
                    background:
                      openModule === module.moduleName
                        ? "#334155"
                        : "transparent",
                  }}
                  onClick={() => toggleModule(module.moduleName)}
                >
                  <div className="d-flex align-items-center gap-2">
                    {module.icon}
                    <span>{module.moduleName}</span>
                  </div>

                  <div>
                    {openModule === module.moduleName ? (
                      <ChevronDown />
                    ) : (
                      <ChevronRight />
                    )}
                  </div>
                </div>

    
                {openModule === module.moduleName && (
                  <div className="ms-3 mt-2">

                    {module.menus.map((menu, i) => (
                      <div
                        key={i}
                        className="p-2 mb-1 rounded d-flex align-items-center gap-2"
                        style={{
                          cursor: "pointer",
                          background:
                            activeMenu === menu.name
                              ? "#2563eb"
                              : "transparent",
                        }}
                        onClick={() => setActiveMenu(menu.name)}
                      >
                        {menu.icon}
                        <span>{menu.name}</span>
                      </div>
                    ))}

                  </div>
                )}
              </div>
            ))}

          </div>

        </div> */}

        {/* Main Content */}
        <div
          className="col-lg-10 col-md-9"
          style={{
            background: "#f1f5f9",
            minHeight: "100vh",
          }}
        >

          {/* Top Navbar */}
          <div
            className="d-flex justify-content-between align-items-center px-4 py-3 shadow-sm"
            style={{ background: "white" }}
          >
            <h4 className="fw-bold m-0">{activeMenu}</h4>

            <div className="d-flex align-items-center gap-3">
              <img
                src="https://i.pravatar.cc/40"
                alt="profile"
                className="rounded-circle"
              />

              <div>
                <h6 className="m-0">Admin User</h6>
                <small className="text-muted">System Administrator</small>
              </div>
            </div>
          </div>

          {/* Dashboard Content */}
          <div className="p-4">

            {/* Dynamic Cards */}
            <div className="row">

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body">
                    <h6>Total Employee</h6>
                    <h2>1,250</h2>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body">
                    <h6>Present Today</h6>
                    <h2>1,180</h2>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body">
                    <h6>Pending Leave</h6>
                    <h2>32</h2>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body">
                    <h6>Medical Cases</h6>
                    <h2>14</h2>
                  </div>
                </div>
              </div>

            </div>

            {/* Table */}
            <div className="card border-0 shadow rounded-4">
              <div className="card-header bg-primary text-white">
                Recent Activities
              </div>

              <div className="card-body table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Department</th>
                      <th>Activity</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Feroz Mahmud</td>
                      <td>IT</td>
                      <td>Promotion Approved</td>
                      <td>13-May-2026</td>
                    </tr>

                    <tr>
                      <td>Nusrat Jahan</td>
                      <td>HR</td>
                      <td>Leave Approved</td>
                      <td>12-May-2026</td>
                    </tr>

                    <tr>
                      <td>Rahim Uddin</td>
                      <td>Accounts</td>
                      <td>Transfer Completed</td>
                      <td>11-May-2026</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

// import React from "react";
// import {
//   PeopleFill,
//   ArrowLeftRight,
//   GraphUpArrow,
//   CalendarCheck,
//   CalendarX,
//   ExclamationTriangleFill,
//   CashStack,
//   FileEarmarkText,
//   PersonBadgeFill,
//   BarChartFill,
//   ClipboardDataFill,
//   BellFill,
// } from "react-bootstrap-icons";

// const dashboardCards = [
//   {
//     title: "Employee Info",
//     count: "1,250",
//     icon: <PeopleFill size={35} />,
//     color: "primary",
//   },
//   {
//     title: "Transfer",
//     count: "48",
//     icon: <ArrowLeftRight size={35} />,
//     color: "info",
//   },
//   {
//     title: "Promotion",
//     count: "32",
//     icon: <GraphUpArrow size={35} />,
//     color: "success",
//   },
//   {
//     title: "Attendance",
//     count: "96%",
//     icon: <CalendarCheck size={35} />,
//     color: "warning",
//   },
//   {
//     title: "Leave",
//     count: "18",
//     icon: <CalendarX size={35} />,
//     color: "danger",
//   },
//   {
//     title: "Disciplinary Action",
//     count: "6",
//     icon: <ExclamationTriangleFill size={35} />,
//     color: "dark",
//   },
//   {
//     title: "Payroll",
//     count: "৳ 12.5M",
//     icon: <CashStack size={35} />,
//     color: "secondary",
//   },
//   {
//     title: "Reports",
//     count: "15",
//     icon: <FileEarmarkText size={35} />,
//     color: "primary",
//   },
//   {
//     title: "Recruitment",
//     count: "24",
//     icon: <PersonBadgeFill size={35} />,
//     color: "info",
//   },
//   {
//     title: "Performance",
//     count: "88%",
//     icon: <BarChartFill size={35} />,
//     color: "success",
//   },
//   {
//     title: "Training",
//     count: "12",
//     icon: <ClipboardDataFill size={35} />,
//     color: "warning",
//   },
//   {
//     title: "Notifications",
//     count: "9",
//     icon: <BellFill size={35} />,
//     color: "danger",
//   },
// ];

// const Dashboard = () => {
//   return (
//     <div className="container-fluid py-4">
//       {/* Header */}
//       <div className="row mb-4">
//         <div className="col-12">
//           <div className="bg-primary text-white rounded p-4 shadow">
//             <h2 className="fw-bold">HR Management Dashboard</h2>
//             <p className="mb-0">
//               Human Resource Information System Overview
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Cards */}
//       <div className="row">
//         {dashboardCards.map((item, index) => (
//           <div
//             className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4"
//             key={index}
//           >
//             <div
//               className={`card border-0 shadow h-100 bg-${item.color} text-white`}
//               style={{
//                 borderRadius: "15px",
//                 transition: "0.3s",
//               }}
//             >
//               <div className="card-body d-flex justify-content-between align-items-center">
//                 <div>
//                   <h6 className="fw-bold">{item.title}</h6>
//                   <h3>{item.count}</h3>
//                 </div>

//                 <div
//                   style={{
//                     background: "rgba(255,255,255,0.2)",
//                     padding: "15px",
//                     borderRadius: "50%",
//                   }}
//                 >
//                   {item.icon}
//                 </div>
//               </div>

//               <div
//                 className="card-footer border-0"
//                 style={{
//                   background: "rgba(0,0,0,0.1)",
//                   cursor: "pointer",
//                 }}
//               >
//                 View Details →
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Summary Table */}
//       <div className="row mt-4">
//         <div className="col-lg-8 mb-4">
//           <div className="card shadow border-0">
//             <div className="card-header bg-dark text-white">
//               <h5 className="mb-0">Recent Employee Activities</h5>
//             </div>

//             <div className="card-body table-responsive">
//               <table className="table table-hover">
//                 <thead>
//                   <tr>
//                     <th>Employee</th>
//                     <th>Department</th>
//                     <th>Action</th>
//                     <th>Date</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   <tr>
//                     <td>Feroz Mahmud</td>
//                     <td>IT</td>
//                     <td>Promotion</td>
//                     <td>13-May-2026</td>
//                   </tr>

//                   <tr>
//                     <td>Rahim Uddin</td>
//                     <td>Accounts</td>
//                     <td>Transfer</td>
//                     <td>12-May-2026</td>
//                   </tr>

//                   <tr>
//                     <td>Karim Hasan</td>
//                     <td>Admin</td>
//                     <td>Leave Approved</td>
//                     <td>11-May-2026</td>
//                   </tr>

//                   <tr>
//                     <td>Nusrat Jahan</td>
//                     <td>HR</td>
//                     <td>Attendance Updated</td>
//                     <td>10-May-2026</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* Quick Actions */}
//         <div className="col-lg-4 mb-4">
//           <div className="card shadow border-0 h-100">
//             <div className="card-header bg-success text-white">
//               <h5 className="mb-0">Quick Actions</h5>
//             </div>

//             <div className="card-body d-grid gap-3">
//               <button className="btn btn-primary">
//                 Add Employee
//               </button>

//               <button className="btn btn-info text-white">
//                 Attendance Report
//               </button>

//               <button className="btn btn-warning text-dark">
//                 Approve Leave
//               </button>

//               <button className="btn btn-success">
//                 Generate Payroll
//               </button>

//               <button className="btn btn-danger">
//                 Disciplinary Records
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;